module.exports = "/assets/img/shuangruan.f6a367067.png";


//////////////////
// WEBPACK FOOTER
// ./src/index/img/shuangruan.png
// module id = 14
// module chunks = 1